'use client'

import * as stylex from '@stylexjs/stylex'
import { sendGTMEvent } from '@next/third-parties/google'
import Link from 'next/link'
import { forwardRef, useRef } from 'react'
import { link } from 'fs'
import { typography } from '../styles/typography'
import { buttonTheme } from './Buttons/buttonThemes.stylex'

export interface NextLinkWithEventPayloadProps
  extends React.ComponentPropsWithoutRef<typeof Link> {
  children: React.ReactNode
  clickEventPayload?: Record<string, unknown>
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  styles?: stylex.StyleXStyles
}
export const NextLinkWithEventPayload = forwardRef<
  HTMLAnchorElement,
  NextLinkWithEventPayloadProps
>(function NextLinkWithEventPayload(
  { children, clickEventPayload, onClick, styles, ...props },
  ref
) {
  function handleClick(e: React.MouseEvent<HTMLAnchorElement>) {
    if (clickEventPayload) {
      sendGTMEvent({ ...clickEventPayload, e })
    }
    if (onClick) {
      onClick(e)
    }
  }

  return (
    <Link
      ref={ref}
      onClick={handleClick}
      {...stylex.props(typography.label, sx.link, styles)}
      {...props}
    >
      {children}
    </Link>
  )
})

const sx = stylex.create({
  link: {
    color: buttonTheme.contentColor,
    textDecoration: { default: 'none', ':hover': 'none' },
  },
})
